import { createElement, getElementOrLogError } from '../../utils/utils';
export class Basket {
    constructor(template, events) {
        this.events = events;
        this.container = getElementOrLogError('.basket', template.content).cloneNode(true);
        if (!this.container)
            console.error('Basket container not found');
        this.title = getElementOrLogError('.modal__title', this.container);
        this.itemList = getElementOrLogError('.basket__list', this.container);
        this.button = getElementOrLogError('.basket__button', this.container);
        this.totalPrice = getElementOrLogError('.basket__price', this.container);
        this.headerButton = getElementOrLogError('.header__basket', document.body);
        this.headerCounter = getElementOrLogError('.header__basket-counter', document.body);
        this.button.addEventListener('click', () => this.events.emit('order:open'));
        this.headerButton.addEventListener('click', () => this.events.emit('basket:open'));
        this.items = [];
    }
    set items(items) {
        if (items.length) {
            this.itemList.replaceChildren(...items);
            this.button.removeAttribute('disabled');
        }
        else {
            this.button.setAttribute('disabled', 'disabled');
            this.itemList.replaceChildren(createElement('p', { textContent: 'Корзина пуста' }));
        }
    }
    updateHeaderCounter(value) {
        this.headerCounter.textContent = String(value);
    }
    updateTotalPrice(price) {
        this.totalPrice.textContent = `${price} синапсов`;
    }
    render() {
        this.title.textContent = 'Корзина';
        return this.container;
    }
}
